'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/styles';
import { AppFormDescription } from './AppFormDescription';
import { AppFormLabel } from './AppFormLabel';
type Props = {
  readonly name: string;
  readonly label?: React.ReactNode;
  readonly endAdornment?: React.ReactNode;
  readonly containerClassName?: string;
  readonly fieldClassName?: string;
  readonly description?: React.ReactNode;
  readonly hideFormMessage?: boolean;
  readonly iconLeft?: React.ReactNode;
  readonly iconRight?: React.ReactNode;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'>;
export const AppField = React.forwardRef<HTMLInputElement, Props>((t0, ref) => {
  const $ = _c(26);
  let containerClassName;
  let description;
  let endAdornment;
  let fieldClassName;
  let hideFormMessage;
  let iconLeft;
  let iconRight;
  let label;
  let name;
  let nativeProps;
  if ($[0] !== t0) {
    ({
      name,
      label,
      endAdornment,
      containerClassName,
      fieldClassName,
      description,
      hideFormMessage,
      iconLeft,
      iconRight,
      ...nativeProps
    } = t0);
    $[0] = t0;
    $[1] = containerClassName;
    $[2] = description;
    $[3] = endAdornment;
    $[4] = fieldClassName;
    $[5] = hideFormMessage;
    $[6] = iconLeft;
    $[7] = iconRight;
    $[8] = label;
    $[9] = name;
    $[10] = nativeProps;
  } else {
    containerClassName = $[1];
    description = $[2];
    endAdornment = $[3];
    fieldClassName = $[4];
    hideFormMessage = $[5];
    iconLeft = $[6];
    iconRight = $[7];
    label = $[8];
    name = $[9];
    nativeProps = $[10];
  }
  const {
    control
  } = useFormContext();
  let t1;
  if ($[11] !== containerClassName || $[12] !== description || $[13] !== endAdornment || $[14] !== fieldClassName || $[15] !== hideFormMessage || $[16] !== iconLeft || $[17] !== iconRight || $[18] !== label || $[19] !== nativeProps || $[20] !== ref) {
    t1 = t2 => {
      const {
        field,
        fieldState
      } = t2;
      return <FormItem className={cn(containerClassName)}><AppFormLabel fieldState={fieldState} label={label} required={nativeProps.required} /><FormControl><div className="relative flex items-stretch overflow-hidden w-full">{iconLeft && <div className="absolute left-3 top-1/2 -translate-y-1/2 transform text-neutral-light-600">{iconLeft}</div>}<Input ref={ref} variant="small" {...nativeProps} value={field.value ?? ""} onChange={event => {
              const value = event.target.value;
              if (nativeProps.type === "number") {
                field.onChange(Number.parseFloat(value));
              } else {
                field.onChange(value);
              }
            }} onBlur={field.onBlur} name={field.name} className={cn("w-full", {
              "border-peach-500 text-peach-900": fieldState.invalid,
              border: !endAdornment
            }, iconLeft && "pl-8", iconRight && "pr-8", fieldClassName)} />{endAdornment && <div className={cn("flex items-center border bg-gray-100 px-2", {
              "border-y-peach-500 border-r-peach-500 text-peach-900": fieldState.invalid,
              "border-gray-100": !fieldState.invalid
            })}>{endAdornment}</div>}{iconRight && <div className="absolute right-3 top-1/2 -translate-y-1/2 transform text-neutral-light-600">{iconRight}</div>}</div></FormControl><AppFormDescription description={description} />{!hideFormMessage && <FormMessage />}</FormItem>;
    };
    $[11] = containerClassName;
    $[12] = description;
    $[13] = endAdornment;
    $[14] = fieldClassName;
    $[15] = hideFormMessage;
    $[16] = iconLeft;
    $[17] = iconRight;
    $[18] = label;
    $[19] = nativeProps;
    $[20] = ref;
    $[21] = t1;
  } else {
    t1 = $[21];
  }
  let t2;
  if ($[22] !== control || $[23] !== name || $[24] !== t1) {
    t2 = <FormField control={control} name={name} render={t1} />;
    $[22] = control;
    $[23] = name;
    $[24] = t1;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  return t2;
});
AppField.displayName = 'AppField';